import { cn } from '@cibli/shared';
import { motion } from 'framer-motion';

import Header, { CloseTypeEnum, CONTENT_MIN_HEIGHT_CLASS } from './Header';

type MainLayoutProps = {
  children: React.ReactNode;
  className?: string;
  headerClassName?: string;
  logoContainerClassName?: string;
  middleContent?: React.ReactNode;
  leftContent?: React.ReactNode;
  rightContent?: React.ReactNode;
  align?: 'center' | 'top-center' | 'top-left';
  padding?: string;
  closeType?: CloseTypeEnum;
  onClose?: () => void;
};

const MainLayout = ({
  children,
  className,
  headerClassName,
  logoContainerClassName = '',
  middleContent,
  leftContent,
  rightContent,
  align = 'center',
  padding = 'p-4 sm:p-8 pb-[72px] sm:pb-8',
  closeType = CloseTypeEnum.Cancel,
  onClose,
}: MainLayoutProps) => {
  return (
    <>
      <Header
        onClose={onClose}
        middleContent={middleContent}
        leftContent={leftContent}
        rightContent={rightContent}
        closeType={closeType}
        className={headerClassName}
        logoContainerClassName={logoContainerClassName}
      />

      <motion.div
        initial={{ opacity: 0, translateY: -20 }}
        animate={{ opacity: 1, translateY: 0 }}
        transition={{ duration: 0.3, ease: 'easeOut' }}
      >
        <div
          className={cn(
            'w-full flex flex-col',
            CONTENT_MIN_HEIGHT_CLASS,
            padding,
            align === 'center'
              ? 'justify-center items-center'
              : align === 'top-center'
                ? 'items-center'
                : undefined,
            className,
          )}
        >
          {children}
        </div>
      </motion.div>
    </>
  );
};

export default MainLayout;
